import {
   CurrentInvoiceProviderAccountInfoQuery,
   InvoiceOfferUrlQuery,
   InvoiceProviderAccountInfo,
} from '@dreryk/egabinet-invoice-frontend-api';

import { useCqrsFind, useCqrsGet } from '@dreryk/command-query-react-common';
import { LoaderSpinner, Message, MessageType } from '@dreryk/react-components';

import { invoiceSharedTranslationKeys } from '../translations';

type InvoicePanelLoaderRenderProps = {
   invoiceOfferUrl: string;
   currentInvoiceProviderAccountInfo: InvoiceProviderAccountInfo | undefined | null;
};

type InvoicePanelLoaderProps = {
   readonly children: (renderProps: InvoicePanelLoaderRenderProps) => JSX.Element;
};

export const InvoicePanelLoader = (props: InvoicePanelLoaderProps): JSX.Element => {
   const { data: invoiceOfferUrl, error: invoiceOfferUrlError, loading: invoiceOfferUrlLoading } = useCqrsGet<string>(
      () => new InvoiceOfferUrlQuery()
   );

   const {
      data: currentInvoiceProviderAccountInfo,
      error: currentInvoiceProviderAccountInfoError,
      loading: currentInvoiceProviderAccountInfoLoading,
   } = useCqrsFind<InvoiceProviderAccountInfo>(() => new CurrentInvoiceProviderAccountInfoQuery());

   if (invoiceOfferUrlLoading || currentInvoiceProviderAccountInfoLoading) {
      return <LoaderSpinner />;
   }

   if (invoiceOfferUrlError || currentInvoiceProviderAccountInfoError) {
      return (
         <Message
            testId={'failedToFetchPanelData'}
            label={invoiceSharedTranslationKeys.fetchError}
            type={MessageType.NEGATIVE}
            displayIndicator
         />
      );
   }

   return props.children({
      invoiceOfferUrl: invoiceOfferUrl,
      currentInvoiceProviderAccountInfo: currentInvoiceProviderAccountInfo,
   });
};
